export const mutations = {
  setInfo(state, payload) {
    state.userInfo = payload
  },
  setBranches(state, payload) {

    let branches = [];
    let tmpBranchesIds = []

    payload.forEach(branch => {
        branches.push({
            text: branch.strNombre,
            value: branch.intIdSitioOficina
        })

        tmpBranchesIds.push(branch.intIdSitioOficina)
    })

    if ( localStorage.getItem('selectedBranches') == null || JSON.parse(localStorage.getItem('selectedBranches')).length <= 0 ) {
      localStorage.setItem('selectedBranches', JSON.stringify(tmpBranchesIds))
    }

    state.branches = branches
  },
  setActiveTrips(state, payload) {
      state.activeTrips = payload
  },
  setFinalizedTrips(state, payload) {
    state.finalizedTrips = payload
  },
  setFinalizedTripsPagination(state, payload) {
    state.finalizedTripsPagination = {
      currentPage: payload.current_page,
      perPage: parseInt(payload.per_page),
      lastPage: payload.last_page,
      totalItems: payload.total
    }
  },
  setLoginState(state, payload) {
    state.isLogged = payload
  },
  setDashboardWasLoaded(state, payload) {
    state.dashboardWasLoaded = payload
  }
}
